module.exports = __webpack_public_path__ + "static/media/03_Follo_Access_campaign_performance.99197dd1.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/advertisers/modules/tutorials/assets/pdfs/en/03_Follo_Access_campaign_performance.pdf
// module id = ./src/advertisers/modules/tutorials/assets/pdfs/en/03_Follo_Access_campaign_performance.pdf
// module chunks = 8